import type { RouteRecordRaw } from 'vue-router';

/**
 * The thread lives *inside* the inbox, not beside it.
 *
 * Nesting is what makes the inbox a real master-detail screen: the list, its
 * filters and its scroll position belong to a component that stays mounted
 * while `:id` changes, so switching threads costs one query instead of a full
 * remount. Only this parent is exported — `registerModules` calls
 * `router.addRoute` for every exported route, so exporting the child too would
 * register it a second time as a top-level record.
 */
export const ticketsRoute: RouteRecordRaw = {
  path: '/tickets',
  name: 'Tickets',
  component: () => import('./pages/TicketsPage.vue'),
  meta: {
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('st:core:tickets:list'),
  },
  children: [
    {
      path: ':id',
      name: 'Ticket',
      component: () => import('./pages/TicketPage.vue'),
      props: true,
      meta: {
        layout: 'main',
        authorize: ({ isGranted }) => isGranted('st:core:tickets:get'),
      },
    },
  ],
};
